import { defaultSwalPreferences } from "app/utils/appHelpers";
import { API_HOST, APP_VERSION } from "app/utils/constants/paths";
import jwtAxios from "axios";
import Swal from "sweetalert2";

const jwtAuthAxios = jwtAxios.create({
    baseURL: API_HOST,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Quien llama, para el Pulso del backend: separa la web de la app en las metricas de uso, dice
// con que build y desde que pantalla salio el request. Ver hermes-backend app/services/pulse/source.rb.
jwtAuthAxios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    config.headers['X-Client'] = 'web';
    config.headers['X-App-Version'] = APP_VERSION;
    config.headers['X-Screen'] = window.location.pathname;
    return config;
});

jwtAuthAxios.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        console.log("Interceptor error")
        console.log(err.response)
        if(err.response) {
            const errorCode = err.response?.data?.error_code;
            if (errorCode === 'subscription_limit_reached') {
                return Promise.reject(err);
            }

            // El pedido ya está en otro viaje activo: el caller muestra un modal
            // de confirmación para traerlo, no un toast de error genérico.
            if (errorCode === 'order_already_assigned') {
                return Promise.reject(err);
            }

            const data = err.response?.data;

            // El backend puede devolver la causa como { errors: [...] } (validaciones)
            // o como { error: "..." } (autorización/negocio). Se prioriza el mensaje
            // explícito para que el usuario vea POR QUÉ falló, no solo "error".
            let msg = ''
            if (Array.isArray(data?.errors) && data.errors.length) {
                msg = data.errors.join('. ')
            } else if (data?.error) {
                msg = data.error
            } else if (err.response?.status === 401) {
                msg = 'No autorizado'
            } else if (err.response?.status === 403) {
                msg = 'No tienes suficientes permisos para visualizar esta información'
            } else {
                msg = 'Error desconocido'
            }
            Swal.mixin(defaultSwalPreferences(Swal)).fire({
                icon: 'error',
                title: msg,
                background: 'error',
            });
        }
        return Promise.reject(err);
    }
);

export const setAuthToken = (token) => {
    if(token) {
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        sessionStorage.setItem('token', token);
    } else {
        delete jwtAuthAxios.defaults.headers.common['Authorization'];
        sessionStorage.removeItem('token');
    }
};

export const getAuthToken = () => {
    return sessionStorage.getItem("token");
};

//todo: define interceptors and other configuration like baseURL, headers etc. here
export default jwtAuthAxios;
